<template>
  <a
    :href="`/model/${model.name_alias}/${model.id}/`"
    class="model-card d-block"
    v-bind="$attrs"
  >
    <div class="model-image_block">
      <a
        :href="`/manufacturer/${model.alias_organization}/${model.id_organization}/`"
        class="d-flex flex-column align-end model_manufacturer-logo"
        :title="`Перейти на страницу ${model.name_organization}`"
      >
        <img
          class="mw-100"
          :src="model.user.role === 'manufacturer' ? model.logo.link+'?size=-x56' : model.user.avatarbasic+'?size=-x56'"
          v-if="model.logo.link !=='' && model.logo.link !== null && model.logo.link !== undefined"
          :alt="model.name_organization"
        />
        <img
          v-else
          class="mw-100"
          src="/dist/assets/front_white/img/svg/no-pic-company.svg"
          alt="no logo"
        />
      </a>
      <img
        itemprop="contentUrl"
        class="model-image"
        v-if="model.link_picture !=='' && model.link_picture !== null && model.link_picture !== undefined"
        :src="model.link_picture"
        :alt="model.name"
      />
      <img
        class="model-image"
        v-else
        src="/dist/assets/front_white/img/svg/no-pic.svg"
        alt="no picture"
      />
    </div>
    <div class="model-descr-wrap">
      <p class="model-descr" itemprop="name">{{model.name_short}}</p>
      <p class="model-category" v-if="gridType === 'big'">{{model.category}}</p>
    </div>
  </a>
</template>

<script>
export default {
  name: 'Card',
  props: {
    modelObject: {
      type: Object,
    },
    gridType: {
      type: String,
      default: 'small',
    },
  },
  data () {
    return {
      model: this.modelObject ? this.modelObject : {
        'id': 812,
        'id_user': 91,
        'date_create': '1480446605',
        'date_update': '29-11-2016',
        'article': 'bimlib4871de8eb3af34c7292c0151c9f09eb2',
        'code_category': 'c0009',
        'code_type': 'typ153',
        'code_class': 'class958',
        'name_short': 'Стул Wishbone',
        'name_alias': 'stulwishbone',
        'rating': 0,
        'meta_title': '',
        'meta_description': '',
        'meta_keywords': '',
        'version_max': 1,
        'version_cur': 1,
        'price': '19500',
        'status': 'success',
        'tags': '',
        'name': 'Стул Wishbone окрашеный',
        'description': 'Описание товара    Стул Wishbone был разработан в 1949 году передовым датским дизайнером мебели Хансом Вегнером. Стул Wishbone был создан под впечатлением от просмотра классических портретов датских торговцев, сидящих на китайских стульях династии Мин. Свое название стул Wishbone («вилка») получил за специфическую форму спинки сиденья.    Также известный как CH24, стул Wishbone окрашенный широко используется при оформлении, например, столовых, а также прочих помещений, легко вписываясь в любой стильный современный интерьер благодаря отсутствию тяжеловесности. Стул Wishbone устойчив и просторен, что позволяет сидящему легко менять позу. Спинка обеспечивает уверенную поддержку, и большинство людей чувствует себя на нем комфортнее, чем на других стульях.    Стулья Wishbone Ханса Вегнера украшают залы Художественного музея в Южном Ютланде (Дания), ECCO, Бундестага, здание Парламента Дании. CH24 считается одной из самых выдающихся работ Вегнера. Всего же его портфолио насчитывает более 500 предметов мебели. Стул Wishbone — на сегодняшний день одна из самых популярных и востребованных работ Ханса Вегнера.',
        'link_url': 'cosmorelax.ru',
        'link_catalog': '',
        'link_instruction': '',
        'link_youtube': '',
        'priority': 1,
        'length': '555',
        'width': '555',
        'height': '760',
        'weight': '0',
        'diametr': '0',
        'version_path': '2016-11-29_221005_v1',
        'normatives': '',
        'link_sertificate': '',
        'region_office': '',
        'tags_arr': [],
        'file_ext_plugins': ['rfa', 'rvt', 'rte', 'ifc'],
        'user': {
          'iduser': '91',
          'email': 'cosmo@bimlib.ru',
          'phone': '',
          'role': 'manufacturer',
          'role_name': 'Производитель',
          'first_name': 'Alice',
          'last_name': 'Cosmo',
          'father_name': '',
          'date': '17-11-2016',
          'avatarbasic': '',
        },
        'id_organization': 88,
        'name_organization': 'Cosmorelax',
        'alias_organization': 'cosmorelax',
        'img_organization': '/uploadsmnf88_1491230184',
        'logo': {
          'image_id': 'mnf88_1491230184',
          'link': '/uploads/organizations/bimlib91906a25ff265444de4894eb036d964c/bimlibc27f4e83425955f8a8dedc378f2ff099.png',
        },
        'phone_organization': '',
        'email_organization': '',
        'site_organization': 'http://www.cosmorelax.ru',
        'sitename_organization': 'www.cosmorelax.ru',
        'site_organization_buy': 'http://www.cosmorelax.ru',
        'region_office_organization': '',
        'organization_models_count': '97',
        'link_picture': '/uploads/picturies/bimlib4871de8eb3af34c7292c0151c9f09eb2/bimlibb086e1d2cac2ec5e5b452dcd11a8f54b.jpg',
        'image_id': '1621',
        'images': [{
          'id': '1621',
          'id_model': '812',
          'date_create': '29-11-2016',
          'date_update': '29-11-2016',
          'link_picture': '/uploads/picturies/bimlib4871de8eb3af34c7292c0151c9f09eb2/bimlibb086e1d2cac2ec5e5b452dcd11a8f54b.jpg',
          'file_extension': 'jpg',
          'order_by': '1',
        }, {
          'id': '1622',
          'id_model': '812',
          'date_create': '29-11-2016',
          'date_update': '29-11-2016',
          'link_picture': '/uploads/picturies/bimlib4871de8eb3af34c7292c0151c9f09eb2/bimlibb12a0ad89621bf3649c29277f534652a.jpg',
          'file_extension': 'jpg',
          'order_by': '1',
        }, {
          'id': '1623',
          'id_model': '812',
          'date_create': '29-11-2016',
          'date_update': '29-11-2016',
          'link_picture': '/uploads/picturies/bimlib4871de8eb3af34c7292c0151c9f09eb2/bimlib8734efe817a68d6f4363999baddb39e5.jpg',
          'file_extension': 'jpg',
          'order_by': '1',
        }, {
          'id': '1624',
          'id_model': '812',
          'date_create': '29-11-2016',
          'date_update': '29-11-2016',
          'link_picture': '/uploads/picturies/bimlib4871de8eb3af34c7292c0151c9f09eb2/bimlib9852267236ce9dae0f61297f59019ad2.jpg',
          'file_extension': 'jpg',
          'order_by': '1',
        }, {
          'id': '1625',
          'id_model': '812',
          'date_create': '29-11-2016',
          'date_update': '29-11-2016',
          'link_picture': '/uploads/picturies/bimlib4871de8eb3af34c7292c0151c9f09eb2/bimlib4ea516ad97e413e3b95143d0a936ec95.jpg',
          'file_extension': 'jpg',
          'order_by': '1',
        }, {
          'id': '1626',
          'id_model': '812',
          'date_create': '29-11-2016',
          'date_update': '29-11-2016',
          'link_picture': '/uploads/picturies/bimlib4871de8eb3af34c7292c0151c9f09eb2/bimlibb4bf75d6aceac6a5b39a2e373accca69.jpg',
          'file_extension': 'jpg',
          'order_by': '1',
        }],
        'images_down': ['/uploads/picturies/bimlib4871de8eb3af34c7292c0151c9f09eb2/bimlibb086e1d2cac2ec5e5b452dcd11a8f54b.jpg', '/uploads/picturies/bimlib4871de8eb3af34c7292c0151c9f09eb2/bimlibb12a0ad89621bf3649c29277f534652a.jpg', '/uploads/picturies/bimlib4871de8eb3af34c7292c0151c9f09eb2/bimlib8734efe817a68d6f4363999baddb39e5.jpg', '/uploads/picturies/bimlib4871de8eb3af34c7292c0151c9f09eb2/bimlib9852267236ce9dae0f61297f59019ad2.jpg', '/uploads/picturies/bimlib4871de8eb3af34c7292c0151c9f09eb2/bimlib4ea516ad97e413e3b95143d0a936ec95.jpg', '/uploads/picturies/bimlib4871de8eb3af34c7292c0151c9f09eb2/bimlibb4bf75d6aceac6a5b39a2e373accca69.jpg'],
        'iPhoneViewer3D': '',
        'Viewer3D': '',
        'AndroidViewer3D': '',
        'files': [{
          'id': '1096',
          'id_model': '812',
          'date_create': '29-11-2016',
          'date_update': '29-11-2016',
          'name': 'wishbonemax.max',
          'path_f': '/uploads/bimmodels/bimlib4871de8eb3af34c7292c0151c9f09eb2/2016-11-29_221005_v1/wishbonemax.max',
          'file_extension': 'max ',
          'file_size': '4644864',
          'file_size_text': '4.43 Mb',
          'downloadModelJson': '{"IdModel":"bimlib4871de8eb3af34c7292c0151c9f09eb2","IdFile":"1096|max|wishbonemax.max","UpdateDate":"1480446605","DownloadUrl":"http:\\/\\/newproject\\/modeldownload\\/812\\/wishbonemax.max\\/0\\/","AdditionalFiles":[]}',
        }],
        'files_ext': ['max'],
        'count_view_models': '6',
        'download_models_count': '3',
        'compare': false,
        'favourite': false,
        'favourite_count': '0',
        'code_category_name': 'Технологическое оборудование',
        'category': 'Технологическое оборудование',
        'code_type_name': 'Мебель',
        'type': 'Мебель',
        'code_class_name': 'Мебель для дома',
        'class': 'Мебель для дома',
        'date_create_str': '29-11-2016',
        'models_view_count': 6,
        'models_download_count': 3,
      },
    }
  },
}
</script>

<style lang="scss" scoped>

</style>
